function waitForJQuery(callback) {
  if (typeof jQuery !== "undefined") {
    callback();
  } else {
    setTimeout(() => waitForJQuery(callback), 100);
  }
}

waitForJQuery(() => {
  const key = "quiz_responses_v2";
  // get plan
  window.plan = (function getPlan() {
    const url = new URL(window.location.href);
    const segments = url.pathname.split('/').filter(Boolean);
    let plan = segments[segments.length - 1];

    if (plan.includes('one-week')) {
      plan = plan.replace('one-week-', '');
    } else if (plan.includes('one-month')) {
      plan = plan.replace('one-month-', '');
    }

    return plan;
  })();

  (function ($) {
    const methods = {
      async getCart() {
        try {
          return await $.ajax({
            type: "GET",
            url: "/cart.js",
            dataType: "json",
          });
        } catch (err) {
          console.error("Erro ao obter o carrinho:", err);
          throw err;
        }
      },
      async addItem(data, discount = null) {
        try {
          await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          });
          if (discount != null) {
            await fetch("/cart/update.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                updates: {},
                discount: discount,
              }),
            });
          }
        } catch (err) {
          console.error("Erro ao adicionar item ao carrinho:", err);
          throw err;
        }
      },

      async updateQuantityItem(lineKey, quantity) {
        try {
          return await $.ajax({
            type: "POST",
            url: "/cart/update.js",
            data: {
              updates: {
                [lineKey]: quantity,
              },
            },
            dataType: "json",
          });
        } catch (err) {
          console.error(
            "Erro ao atualizar a quantidade do item no carrinho:",
            err
          );
          throw err;
        }
      },

      async clearCart() {
        return await $.ajax({
          type: "POST",
          url: "/cart/clear.js",
          data: {},
          dataType: "json",
        });
      },
      async clearCartAttributes() {
        const attributesToClear = ["_delivery", "_filter", "observacao"];

        const emptyAttributes = {};
        attributesToClear.forEach(key => {
          emptyAttributes[key] = "";
        });

        return await $.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: {
            attributes: emptyAttributes
          },
          dataType: "json"
        });
      },


      async addAttributes(attributes = {}) {
        try {
          return await $.ajax({
            type: "POST",
            url: "/cart/update.js",
            data: {
              attributes: {
                ...attributes,
              },
            },
            dataType: "json",
          });
        } catch (err) {
          console.error("Erro ao adicionar atributos ao carrinho:", err);
          throw err;
        }
      },

      async addItems(products, discount = null, attributes = {}) {
        try {
          const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              items: products,
              discount: discount,
            }),
          });
          if (discount != null) {
            await fetch("/cart/update.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                updates: {},
                discount: discount,
                attributes: {
                  ...attributes,
                },
              }),
            });
          }
          if (res.ok) {
            return await res.json();
          }
        } catch (e) {
          throw new Error(e);
        }
      },
    };
    window.FormEvents = methods;
  })(jQuery);

  (function ($) {
    const methods = {
      async buildCart() {
        const cart = await FormEvents.getCart();
        try {
          const cartItemsSection = await $.ajax({
            url: `/cart?section_id=cart-items`,
          });
          const cartTotal = await $.ajax({
            url: `/cart?section_id=result-cart-total`,
          });
          const parser = new DOMParser();
          const cartItemsContent = parser.parseFromString(
            cartItemsSection,
            "text/html"
          );
          const cartTotalContent = parser.parseFromString(
            cartTotal,
            "text/html"
          );
          const $listItems = $(cartItemsContent).find("#cart-items");
          const $cartTotal = $(cartTotalContent).find("#cart-total");

          if (!$listItems.length) {
            console.warn("No cart items found in the response.");
            return;
          }
          if (!$cartTotal.length) {
            console.warn("No cart items found in the response.");
            return;
          }

          $("#cart-items").empty().html($listItems);
          $("#cart-total").empty().html($cartTotal);

          /* Quantity items*/
          const itemCount = cart.item_count;
          let messageItems = itemCount > 1 ? "Items" : "Item";

          $(".cart-items-count").html(`${itemCount} ${messageItems}`);

          /* Shipping Bar Calculate*/
          const shippingText = [
            { threshold: 0, message: "Buy and Get Free Delivery :truck:" },
            { threshold: 25, message: "Nice! Add a little more to unlock Free Delivery" },
            { threshold: 50, message: "Almost there—Free Delivery is close :muscle:" },
            { threshold: 75, message: "So close! Just a bit more for Free Delivery" },
            { threshold: 100, message: "Congrats! You've unlocked Free Delivery :tada:" },
          ];

          function getShippingMessage(progress) {
            let currentMessage = shippingText[0].message;
            for (let i = 0; i < shippingText.length; i++) {
              if (progress >= shippingText[i].threshold) {
                currentMessage = shippingText[i].message;
              } else {
                break;
              }
            }
            return currentMessage;
          }

          const cartTotalFormat = cart.total_price / 100;
          const valueFreeShipping = $(".shipping-bar").data("shipping");
          let width = ((cartTotalFormat / valueFreeShipping) * 100).toFixed(1);
          width = Math.max(0, width);
          width = Math.min(width, 100);

          $(".cart-shipping-fill").css({
            width: width + "%",
          });

          const message = getShippingMessage(width);
          $(".shipping-bar-text").text(message);
          $('.total-price').addClass('hidden');
          $('.total-price-omt').removeClass('hidden');
        } catch (err) {
          console.error("Erro ao construir o carrinho:", err);
        }
      },
      async changeAtcButtonText() {
                try {
                    const cart = await FormEvents.getCart();
                    $('.product-card').each(function () {
                        const $productCard = $(this);
                        const productId = $productCard.data('variant-id');
                        const product = cart.items.find(item => item.id == productId);
                        
                        if (product) {
                            $productCard.find('.quantity-wrapper').removeClass('hidden');
                            $productCard.find('#product-form-quantity').empty().text(product.quantity);
                            const $atcButton = $productCard.find('#AddToCartButton .add-to-cart-text');
                            $atcButton.closest('.btn-add-tocart').addClass('hidden');
                            $atcButton.html(`
                                <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.60128 10.6499L0.670898 6.71952L2.46204 4.92838L4.60128 7.07395L10.8544 0.814453L12.6456 2.60559L4.60128 10.6499Z" fill="#7ED22A"/>
                                </svg>
                                ${product.quantity}
                                Added
                                `);
                        } else {
                            $productCard.find('.quantity-wrapper').addClass('hidden');
                            const $atcButton = $productCard.find('#AddToCartButton .add-to-cart-text');
                            $atcButton.closest('.btn-add-tocart').removeClass('hidden');
                            $atcButton.html(`Add to cart`);
                        }
                    });
                } catch (err) {
                    console.error("Erro ao alterar o texto do botão 'Add to Cart':", err);
                }
            },
      async initCart(discount = null) {
        try {
          const cart = await FormEvents.getCart();
          const storage = localStorage.getItem(key);
          const pkQty = storage ? JSON.parse(storage)?.pk_qty : 0;

          let items = [];
          $(".product-card").each(function (index) {
            if (index < 5) {
              const $productCard = $(this);
              const productId = $productCard.data("variant-id");
              items.push({
                id: productId,
                quantity: 1,
                selling_plan: $productCard.data("productSellingPlan"),
              });

              if (index == pkQty - 1) {
                return false;
              }
            }
          });
          $(".cart-item").each(function () {
            const $productCard = $(this);
            const productId = $productCard.data("variant-id");
            const quantity = $productCard.data("quantity");
            items.push({
              id: productId,
              quantity: quantity,
              selling_plan: $productCard.data("product-selling-plan-id"),
            });
          });
          return await FormEvents.addItems(items, discount);
        } catch (err) {
          console.error("Erro ao inicializar o carrinho:", err);
          throw err;
        }
      },
      async buildDeliveryDatesWidget() {
        document.querySelector('.delivery-pickup-widget')?.classList.remove('hidden');
        const delivery_options = await waitForKey("delivery_dates_and_cut_offs");
        if (!delivery_options) return;

        const $select = $(".delivery-pickup-widget .select-date");
        if ($select.hasClass("initialized")) return;

        const { sunday, wednesday } = delivery_options.next_available_dates;

        const dates = [sunday, wednesday].map(({ timestamp }) => {
            const date = new Date(timestamp);
            return (date.getDate() === 25 && date.getMonth() === 11 && date.getFullYear() === 2024)
                ? new Date(2025, 0, 1).getTime()
                : timestamp;
        });

        // Semana ativa vinda do localStorage (1 a 8)
        const baseWeek = getWeekActive(); // ex: 4
        
        // Domingo principal (semana atual)
        if (sunday.show_sunday) {
        $("<option>")
            .val(dates[0])
            .text(formatDate(dates[0]))
            .attr("data-type", "sunday-main")
            .attr("data-week", baseWeek) // semana atual
            .appendTo($select);
        }
        // Wednesday (quarta) recebe sempre a semana atual (mesma do domingo base)
        if (wednesday.show_wednesday) {
            $("<option>")
                .val(dates[1])
                .text(formatDate(dates[1]))
                .attr("data-type", "wednesday")
                .attr("data-week", baseWeek)
                .appendTo($select);
        }



        // Domingo principal + próximos 4 domingos
        if ((sunday.show_sunday || wednesday.show_wednesday) && !location.pathname.includes('chefs')) {
            const baseSundayTs = dates[0];
            const baseSundayDate = new Date(baseSundayTs); 

            // Próximos 4 domingos com week + wrap 1–8
            const NUM_EXTRA_SUNDAYS = 8;
            const init = sunday.show_sunday ? 1 : 0;
            for (let i = init; i <= NUM_EXTRA_SUNDAYS; i++) {
                const nextSunday = new Date(baseSundayDate);
                nextSunday.setDate(baseSundayDate.getDate() + 7 * i);
                const ts = nextSunday.getTime();

                const weekValue = getNextWeekValue(baseWeek, i, sunday.show_sunday); // 4→5,6,7,8; 5→6,7,8,1 etc.

                $("<option>")
                    .val(ts)
                    .text(formatDate(ts))
                    .attr("data-type", "sunday-extra")
                    .attr("data-index", i)        // opcional
                    .attr("data-week", weekValue) // 1–8 com volta
                    .appendTo($select);
            }
        }

        $select.addClass("initialized");
          },
        };

    window.CartDrawerAPI = methods;
  })(jQuery);
});
const formatDate = (timestamp) => {
  const date = new Date(timestamp);
  const day = date.getDate();
  const suffix = ["st", "nd", "rd"][(day % 10) - 1] || "th";
  const dayName = date.toLocaleString("en-CA", { weekday: "long" });
  const month = date.toLocaleString("en-CA", { month: "short" });
  const year = date.getFullYear();
  return `${dayName} - ${month} ${day}${suffix}, ${year}`;
};

function getWeekActive() {
    const stored = localStorage.getItem("weekActive");
    let value = parseInt(stored, 10);

    if (Number.isNaN(value) || value < 1 || value > 8) {
        value = 1;
    }

    return value;
}

function getNextWeekValue(baseWeek, offset, showSunday = null) {
  offset = showSunday === false ? offset + 1 : offset;
    // baseWeek: 1–8, offset: 1,2,3,4...
    // Ex: baseWeek=5, offset=3 → ((5-1+3)%8)+1 = 8
    return ((baseWeek - 1 + offset) % 8) + 1;
}

const waitForKey = (key, interval = 100) =>
  new Promise((resolve) => {
    const check = () => {
      const item = localStorage.getItem(key);
      item ? resolve(JSON.parse(item)) : setTimeout(check, interval);
    };
    check();
  });


$(document).on('click', '.one-month-info', async function (e) {  
    e.preventDefault();
    $('body').addClass('no-scroll');
    const $productCard = $(this).closest('.product-card');
    const productHandle = $productCard.data('product-handle');
    const productTitle = $productCard.data('product-short-title');
    const productId = $productCard.data('product-id');
    const productVariantId = $productCard.data('variant-id');
    const modal = $productCard.find('.card-modal-wrapper');
    modal.css('display', 'flex');
    const caracteresMax = 150;
    const seeMoreText = $('.show-more-description');
    seeMoreText.each(function () {
      const description = $(this).prev();
      if(description.text().trim().length > caracteresMax) {
          $(this).removeClass('hidden');
      }
    });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'product_modal_opened',
        product_handle: productHandle,
        title: productTitle,
        product_id: productId,
        variant_id: productVariantId
    });
});
$(document).on('click', '.icon-info', async function (e) {
    e.preventDefault();
    const $productCard = $(this).closest('.product-card');
    const productHandle = $productCard.data('product-handle');
    const productTitle = $productCard.data('product-short-title');
    const productId = $productCard.data('product-id');
    const productVariantId = $productCard.data('variant-id');
    const product = await $.ajax({url: `/products/${productHandle}?section_id=card-modal`});
    const parser = new DOMParser();
    const cartItemsContent = parser.parseFromString(product, 'text/html');
    const $listItems = $(cartItemsContent).find('#card-modal');
    $('#modal-content').empty().html($listItems);
    $('.card-modal-wrapper:not(.one-month-card-modal-wrapper)').css('display', 'flex');
    $('body').addClass('no-scroll');
    const caracteresMax = 150;
    const seeMoreText = $('.show-more-description');
    seeMoreText.each(function () {
        const description = $(this).prev();
        if(description.text().trim().length > caracteresMax) {
            $(this).removeClass('hidden');
        }
    });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'product_modal_opened',
        product_handle: productHandle,
        title: productTitle,
        product_id: productId,
        variant_id: productVariantId
    });
});
$(document).on('click', '.modal-overlay, .close-modal', async function (e) {
    e.preventDefault();
    $('.card-modal-wrapper').css('display', 'none');
    $('body').removeClass('no-scroll');
});
$(document).on('click', '.see-more', async function (e) {
  const $this = $(this).closest('.section-products__cart');
  $this.toggleClass('show-cart');
  if ($this.hasClass('show-cart')) {
    $this.find('.see-more-text').text("See less");
    $('body').addClass('no-scroll');
  } else {
    $this.find('.see-more-text').text("See more");
    $('body').removeClass('no-scroll');
  }
});
$(document).on('submit', '#discount-form', async function (e) {
  e.preventDefault();
  const $form = $(this);
  const code = $form.find('input[name="discount"]').val().trim();
  fetch(`/discount/${code}`).then(()=> {
    fetch('/cart?view=discount', {}).then(function(res){return res.text();})
      .then(async function(data) {
          let dataObject = JSON.parse(JSON.stringify(data));
          dataObject = JSON.parse(dataObject);
          const appliedCodes = dataObject.discounts.map(i => i.title.trim().toLowerCase());
          if (appliedCodes.includes(code.trim().toLowerCase())) {
              $('.discount-info').text(`Discount code applied: ${code}`);
              $('.discount-info').removeClass('hidden');
              await CartDrawerAPI.buildCart();
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                  event: 'discount_applied',
                  discount_code: code
              });
          } else {
              $('.discount-info').text(`${code} is not a valid discount code.`);
              $('.discount-info').removeClass('hidden');
          }
      })
  })
  
});
$(document).on('click', '.discount-code-remove', async function (e) {
    e.preventDefault();
    fetch("/checkout?discount=%20");
    await CartDrawerAPI.buildCart();
    $('.discount-info').addClass('hidden').empty();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'discount_removed',
    });
});
$(document).on('click', '.see-all', function (e) {
    const card = e.target.closest('.product-card');
    $(card).find(`.icon-info`).trigger('click');
});
$(document).on("change", ".delivery-pickup-widget select", function () {
    let formattedDate;
    let selectedValue;
    if ($(this).hasClass("select-date")) {
        const selectedTimestamp = parseInt($(this).val(), 10);
        formattedDate = formatDate(selectedTimestamp);
        selectedValue = $(".select-delivery").val();
    }
    if ($(this).hasClass("select-delivery")) {
        selectedValue = $(this).val();
        const selectedTimestamp = parseInt($(".select-date").val(), 10);
        formattedDate = formatDate(selectedTimestamp);
    }
    if (selectedValue === "pickup") {
        $(".pickup-address").removeClass("hidden");
    } else {
        $(".pickup-address").addClass("hidden");
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'delivery_method_changed',
        delivery_pickup_selection: formattedDate,
        delivery_type: selectedValue
    });
});
$(document).on('click', '.product-tag-support, .product-noresults__actions .talk-support', async function (e) {
    e.preventDefault();
    $('#zsiq_float').trigger('click');
});
$(document).on('click', '.show-more-description', async function (e) {
    $(this).prev().toggleClass('expanded');
    $(this).text(
        $(this).prev().hasClass('expanded') ? 'Show less' : 'Show more'
    );
});
$(document).on('click', '.chat-icon, .chat-icon svg', async function (e) {
    const $this = $(this).closest('.chat-icon');
    $('#zsiq_float').trigger('click');
});

//verifica se os produtos brinde estão no carrinho ou não, se sim esconde o quantity 
async function verifyGift() {
    const giftProductIds = [44731949252787];
    const cart = await FormEvents.getCart();
    for (const productId of giftProductIds) {
        const productInCart = cart.items.find(item => item.id === productId);
        if (productInCart) {
            $(`.cart-item[data-variant-id="${productId}"]`).find('.quantity-wrapper').addClass('hidden');
        }
    }
}

async function changeDiscountDisplay(page=null) {
  const pageHandle = sessionStorage.getItem('page_handle') ?? '';
  const discount = document.querySelector('.discount-code');
  const discountPartner = document.querySelector('.discount-partner');
  const discountApply = document.querySelectorAll('.discount-code-wrapper');
  const shippingBar = document.querySelector('.shipping-bar-wrapper');

  if (pageHandle.includes('partner-')) {
      discount?.classList.add('hidden');
      discountApply?.forEach(el => el.classList.add('hidden'));
      discountPartner?.classList.remove('hidden');
      shippingBar?.classList.add('hidden');
  } else {
      discount?.classList.remove('hidden');
      discountApply?.forEach(el => el.classList.remove('hidden'));
      discountPartner?.classList.add('hidden');
      shippingBar?.classList.remove('hidden');
  }
  if(page == 'one-month') {
      const discountOneMonth = document.querySelector('.discount-one-month-campaign');
      discountOneMonth?.classList.remove('hidden');
      const price = parseFloat($('#product-list-container').data('priceBundle'));
      const comparePrice = parseFloat($('#product-list-container').data('compare-price-bundle'));
      discountOneMonth ? discountOneMonth.querySelector('.discount-value-partner').textContent = `-$${(comparePrice - price).toFixed(2)}` : null;
  } else {
      const discountOneMonth = document.querySelector('.discount-one-month-campaign');
      discountOneMonth?.classList.add('hidden');
  }
}

//função para adicionar brinde ao carrinho se não tiver no carrinho. Se já tiver, não adiciona novamente
async function addGiftPartnerProducts() {
    const giftProductIds = [44731949252787];
    const cart = await FormEvents.getCart();
    const itemsToAdd = [];
    for (const productId of giftProductIds) {
        const productInCart = cart.items.find(item => item.id === productId);

        if (!productInCart) {
            itemsToAdd.push({
                id: productId,
                quantity: 1,
                properties: {
                    "Option" : "gift",
                },
            });
        }
    }
    if (itemsToAdd.length > 0) {
        await FormEvents.addItems(itemsToAdd);
    }
}
//função para remover o brinde do carrinho
async function removeGiftPartnerProducts() {
    const giftProductIds = [44731949252787];
    const cart = await FormEvents.getCart();
    for (const item of cart.items) {
        if (giftProductIds.includes(item.id)) {
            await FormEvents.updateQuantityItem(item.key, 0);
        }
    }
}

//função para fazer scroll até a seção das meals
function initPartner() {
    const pageHandle = sessionStorage.getItem('page_handle') ?? '';
    if(pageHandle == "meal-plan-offer") return;
    const el = document.getElementById('section-products__header');
    if (el) {
    const offset = -90;
    const y =
        el.getBoundingClientRect().top +
        window.pageYOffset +
        offset;

    window.scrollTo({
        top: y,
        behavior: 'smooth'
    });
    }
}